// extracted by mini-css-extract-plugin
export var button = "l_5";
export var input = "l_3";
export var toolbar = "l_bh";
export var userOptions = "l_1";
export var wordHelperPage = "l_bg";